<template>
  <div>
    <vs-tabs :value="tabValue">
      <vs-tab label="정기교육" @click.prevent="onClickTab(0)" />
      <vs-tab label="정기 교육 엑셀 업로드" @click.prevent="onClickTab(1)" />
      <vs-tab label="채용시 교육" @click.prevent="onClickTab(2)" />
      <vs-tab label="채용시 교육 엑셀 업로드" @click.prevent="onClickTab(3)" />
      <vs-tab label="관리감독자 교육" @click.prevent="onClickTab(4)" />
      <vs-tab label="관리감독자 교육 엑셀 업로드" @click.prevent="onClickTab(5)" />
    </vs-tabs>

    <vx-card class="w-full">
      <div class="flex justify-between items-center">
        <h4>{{ boardLabel }}</h4>
        <vs-button color="secondary" @click="onClickSave">등록</vs-button>
      </div>

      <!-- 기본정보 -->
      <field-select-module
        title="작성자 정보"
        v-model="form.stdInfo"
        :typeslabel="{
          date: '등록일',
        }"
        :board="board"
        :types="['department', 'com_name', 'rank', 'writer_name', 'date']"
        class="mt-28px"
      />

      <!-- 교육 정보 -->
      <div class="mt-28px">
        <h5 class="mb-4"><i class="dot"></i> 교육 정보</h5>
        <div class="writeGridContainer">
          <div>
            <div>연도</div>
            <vs-input type="number" v-model="form.연도" :readonly="board.readonly" />
          </div>
        </div>
        <div class="writeGridContainer">
          <div>
            <div>반기</div>
            <div class="time">
              <vs-radio v-model="form.반기" vs-name="반기" vs-value="상반기" :readonly="board.readonly">상반기</vs-radio>
              <vs-radio v-model="form.반기" vs-name="반기" vs-value="하반기" :readonly="board.readonly">하반기</vs-radio>
            </div>
          </div>
        </div>
      </div>

      <!-- 파일 업로드 -->
      <div class="mt-28px">
        <div class="writeGridContainer">
          <div class="writeGridLineItem">
            <div>파일 업로드</div>
            <div>
              <vs-button color="secondary" type="border" :href="excelLink">엑셀 템플릿 다운로드</vs-button>
              <vs-button color="secondary" class="ml-2" @click="onClickExcelUpload"> 작성 엑셀 업로드 </vs-button>
              <input v-show="false" ref="excelInput" type="file" multiple @change="readFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
            </div>
          </div>
        </div>
      </div>

      <!-- 등록 대상 종사자 정보 -->
      <div class="mt-28px">
        <div class="flex justify-between items-center mt-6 mb-4">
          <h5><i class="dot"></i> 등록 대상 종사자 정보</h5>
          <vs-button color="secondary" type="border" @click="onClickCheckRemove">선택삭제</vs-button>
        </div>

        <div style="max-height: 1070px; overflow-y: auto">
          <table>
            <colgroup>
              <col width="50" />
              <col width="50" />
              <col width="80" />
              <col v-for="_ in 6" :key="`col_${_}`" />
              <col width="100" />
            </colgroup>
            <thead>
              <th><vs-checkbox :value="0 < excelData.length && excelData.length === checkList.length" @click.native="checkAll" class="check" /></th>
              <th>No.</th>
              <th>지역</th>
              <th>급별</th>
              <th>기관(학교명)</th>
              <th>직종</th>
              <th>성명</th>
              <th>이수여부</th>
              <th>미이수 사유</th>
              <th>수정/삭제</th>
            </thead>
            <tbody v-for="(excel, excel_i) in excelData" :key="`${excel_i}_${excel[0]}`">
              <tr>
                <td><vs-checkbox :vs-value="excel_i" v-model="checkList" class="check" /></td>
                <td>{{ excel_i + 1 }}</td>
                <!-- 지역 -->
                <td>
                  <p v-if="editExcelIndex === excel_i">{{ editExcelData.지역 }}</p>
                  <p v-else>{{ excel.지역 }}</p>
                </td>
                <!-- 급별 -->
                <td>
                  <p v-if="editExcelIndex === excel_i">{{ editExcelData.급별 }}</p>
                  <p v-else>{{ excel.급별 }}</p>
                </td>
                <!-- 기관 -->
                <td>
                  <field-selector v-if="editExcelIndex === excel_i" class="w-full" :value="editExcelData.기관Data && editExcelData.기관Data.id" @select="onSelectField" />
                  <div v-else>
                    <div class="flex items-center justify-center gap-2">
                      <p>{{ excel.기관 || "-" }}</p>
                      <img v-if="excel.err기관" src="@/assets/images/icon/icon-circle-alert-red.svg" />
                      <img v-else src="@/assets/images/icon/icon-circle-success-green.svg" />
                    </div>
                    <p v-if="excel.err기관" class="errMsg">{{ excel.err기관 }}</p>
                  </div>
                </td>

                <!-- 직종 -->
                <td>
                  <ml-input v-if="editExcelIndex === excel_i" v-model="editExcelData.직종" class="w-full" />
                  <p v-else>{{ excel.직종 }}</p>
                </td>

                <!-- 성명 -->
                <td>
                  <ml-input v-if="editExcelIndex === excel_i" v-model="editExcelData.성명" class="w-full" />
                  <p v-else>{{ excel.성명 }}</p>
                </td>

                <!-- 이수여부 -->
                <td>
                  <ml-input v-if="editExcelIndex === excel_i" v-model="editExcelData.이수여부" class="w-full" />
                  <p v-else>{{ excel.이수여부 }}</p>
                </td>

                <!-- 미이수사유 -->
                <td>
                  <ml-input v-if="editExcelIndex === excel_i" v-model="editExcelData.미이수사유" class="w-full" />
                  <p v-else>{{ excel.미이수사유 }}</p>
                </td>

                <td>
                  <div class="flex justify-center gap-3">
                    <fragment v-if="editExcelIndex === excel_i">
                      <button @click="onClickFinshExcelData(excel_i)">
                        <feather-icon icon="CheckIcon" svgClasses="h-5 w-5" />
                      </button>
                      <button @click="onClickCancelExcelData()">
                        <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
                      </button>
                    </fragment>
                    <fragment v-else>
                      <button @click="onClickEditExcelData(excel_i)">
                        <feather-icon icon="Edit2Icon" svgClasses="h-5 w-5" />
                      </button>
                      <button @click="onClickRemoveExcelData(excel_i)">
                        <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5" />
                      </button>
                    </fragment>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import DateSelector from "@/components/selector/DateSelector";
import FieldSelector from "@/components/selector/FieldSelector";
import CategorySelector from "@/components/selector/CategorySelector";
import XLSX from "xlsx";
import moment from "moment";
import HttpRequest from "@/util/HttpRequest";
import config from "/public/config";

export default {
  components: { FieldSelector, CategorySelector, FieldSelectModule, DateSelector },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    boardId() {
      return Number(this.$route.name.replace("completionresults", ""));
    },
    tabValue() {
      switch (this.boardId) {
        case 570:
          return 1;
        case 576:
          return 3;
        case 577:
          return 5;
      }
    },
    excelLink() {
      return `${config.BASE_API_URL}/storage/app/media/%EC%95%88%EC%A0%84%EA%B4%80%EB%A6%AC%EC%8B%9C%EC%8A%A4%ED%85%9C_%EC%A0%95%EA%B8%B0%EC%95%88%EC%A0%84%EB%B3%B4%EA%B1%B4%EA%B5%90%EC%9C%A1%EC%9D%B4%EC%88%98%ED%98%84%ED%99%A9.xlsx`;
    },
    boardLabel() {
      switch (this.boardId) {
        case 570:
          return "정기 교육 엑셀 업로드";
        case 576:
          return "채용시 교육 엑셀 업로드";
        case 577:
          return "관리감독자 교육 엑셀 업로드";
      }
    },
  },
  data() {
    return {
      board: {
        projectTitle: this.$store.state.project.projectInfo.field_name,
        writer: {}, //작성자 정보
      },

      form: {
        stdInfo: {},
        연도: new Date().getFullYear(),
        반기: "상반기",
        company: null,
      },

      editExcelIndex: null,
      editExcelData: null,
      excelData: [],
      checkList: [],
    };
  },
  async created() {
    this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "안전·보건 교육" }, { title: "안전보건 교육 이수결과", active: true }]);
  },
  async mounted() {
    await this.init();
  },
  methods: {
    async init() {
      await this.$store.dispatch("USER_INFO");
      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        department: this.$store.state.auth.userInfo.department,
        section: this.$store.state.auth.userInfo.section,
        rank: this.$store.state.auth.userInfo.rank,
        com_name: "",
      };

      await this.$store.dispatch("company/LOAD_COMPANY", {
        companyId: this.board.writer.company_id,
      });
      this.board.writer.com_name = this.$store.state.company.companyInfo.com_name;
      if (!this.board.writer.section) {
        this.board.writer.section = this.board.writer.com_name;
      }
    },
    onClickExcelUpload() {
      const excelInput = this.$refs.excelInput;
      excelInput.value = null;
      excelInput.click();
    },
    // 엑셀데이터 파싱
    async readFile(event) {
      this.loading(true);
      await this.$nextTick();

      // get File object from input tag
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        // declare FileReader, temp result
        const reader = new FileReader();
        let tmpResult = {};

        // if you use "this", don't use "function(e) {...}"
        reader.onload = async (e) => {
          let data = e.target.result;
          data = new Uint8Array(data);
          // get excel file
          let excelFile = XLSX.read(data, { type: "array", cellDates: true });

          // get prased object
          excelFile.SheetNames.forEach(function (sheetName) {
            const roa = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], { header: 1 });
            if (roa.length) tmpResult[sheetName] = roa;
          });

          let _data = tmpResult[excelFile.SheetNames[0]].filter((data) => 0 < data.length).slice(3);
          _data = _data.filter((data) => data[0] !== "샘플");

          // ==== API호출을 최소화하기 위해 중복된 데이터는 제거한다.====
          // FIELD : API를 호출하여 존재하는 데이터만 apiSchoolField에 담는다.
          const excelSchoolField = [...new Set(_data.map((data) => data[1]))].filter((item) => !!item);
          let apiSchoolField = [];
          await Promise.all(
            excelSchoolField.map(async (item) => {
              const loadSchoolField = await HttpRequest.get("/api/v1/field", {
                params: {
                  projectId: this.projectId,
                  code: "school",
                  keyword: item,
                },
              });

              if (0 < loadSchoolField.data.length) {
                const check = loadSchoolField.data.find((ls) => ls.field_name === item);
                if (check) apiSchoolField.push(check);
              }
            })
          );

          // ==== DATA SET ===
          const objDatas = _data.map((data) => {
            const rd = {
              지역: "-",
              급별: "-",
              기관: !!data[1] ? data[1] : "-",
              기관Data: null,
              err기관: "",
              직종: !!data[2] ? data[2] : "-",
              성명: !!data[3] ? data[3] : "-",
              이수여부: !!data[4] ? data[4] : "-",
              미이수사유: !!data[5] ? data[5] : "-",
            };

            const findSchoolField = apiSchoolField.find((sf) => sf.field_name === rd.기관);
            if (!!rd.기관 && findSchoolField) {
              rd.지역 = this.setSi(findSchoolField.address);
              rd.급별 = findSchoolField.facility_category.cat3;
              rd.기관Data = findSchoolField;
            } else if (!!rd.기관 && rd.기관 !== '-') rd.err기관 = "입력된 데이터가 검색되지 않습니다.";
            else rd.err기관 = "기관(학교명)이 입력되지 않았습니다.";

            return rd;
          });

          this.excelData = [...this.excelData, ...objDatas];
        };
        reader.readAsArrayBuffer(file);
      }

      this.loading(false);
    },

    // 수정버튼이 눌렸을때
    onClickEditExcelData(index) {
      this.editExcelData = JSON.parse(JSON.stringify(this.excelData[index]));
      this.editExcelIndex = index;
    },

    // 수정을 완료했을때
    onClickFinshExcelData(index) {
      let _data = JSON.parse(JSON.stringify(this.editExcelData));

      // 기관이 바뀌었으면 err기관을 초기화한다.
      if (this.excelData[index].기관 !== this.editExcelData.기관) _data.err기관 = "";

      this.$set(this.excelData, index, _data);
      this.onClickCancelExcelData();
    },
    onClickCancelExcelData() {
      this.editExcelData = null;
      this.editExcelIndex = null;
    },
    onClickRemoveExcelData(index) {
      this.excelData.splice(index, 1);
    },
    checkAll() {
      if (0 < this.excelData.length && this.excelData.length === this.checkList.length) this.checkList = [];
      else this.checkList = this.excelData.map((_, i) => i);
    },
    onClickCheckRemove() {
      if (this.checkList.length < 1) return;
      this.excelData = this.excelData.filter((_, i) => !this.checkList.includes(i));
      this.checkList = [];
    },
    onSelectField(value) {
      if (value.field_name) {
        this.$set(this.editExcelData, "기관", value.field_name);
        this.$set(this.editExcelData, "기관Data", value);
        this.$set(this.editExcelData, "err기관", []);

        if (value.address) this.$set(this.editExcelData, "지역", this.setSi(value.address));
        else this.$set(this.editExcelData, "지역", "");

        if (value.facility_category) this.$set(this.editExcelData, "급별", value.facility_category.cat3);
        else this.$set(this.editExcelData, "급별", "");
      } else {
        this.$set(this.editExcelData, "기관", "");
        this.$set(this.editExcelData, "기관Data", null);
        this.$set(this.editExcelData, "err기관", ["입력된 데이터가 검색되지 않습니다."]);

        this.$set(this.editExcelData, "지역", "");
        this.$set(this.editExcelData, "급별", "");
      }
    },
    onClickSave() {
      // 엑셀 데이터가 없을때 에러
      if (this.excelData.length < 1) {
        this.customAlert("엑셀 업로드 정보가 없습니다");
        return;
      }

      // 학교(기관)명이 없을때 에러
      if (this.excelData.some((ed) => ed.err기관)) {
        this.customAlert("학교(기관)명이 입력되지 않은 데이터가 있습니다");
        return;
      }

      this.loading(true);

      const header = { full: moment().format("YYYY-MM-DD"), month: Number(moment().format("MM")), year: Number(moment().format("YYYY")) };
      const posts = this.excelData.map((ed) => {
        const stdInfo = {
          ...this.form.stdInfo,
          project_name: ed.기관Data.project.field_name,
        };

        const content = {
          header,
          body: {
            stdInfo,
            지역: ed.지역,
            급별: ed.급별,
            기관: ed.기관Data.id,
            기관Data: ed.기관Data,
            직종: ed.직종,
            성명: ed.성명,
            연도: this.form.연도,
            반기: this.form.반기,
            이수여부: ed.이수여부,
            미이수사유: ed.미이수사유,
            fileList: [],
          },
        };

        console.log("content", content);

        return { title: "정기 위험성평가", content: JSON.stringify(content), projectId: this.projectId };
      });

      HttpRequest.put(`/api/v1/board/post/${this.boardId}/multiple`, { posts })
        .then((response) => {
          // 초기화
          this.excelData = [];
          this.editExcelData = [];
          this.editExcelIndex = null;

          this.loading(false);
          this.customAlert(`${this.boardLabel}가 완료되었습니다`, this.boardLabel);
        })
        .catch(({ response }) => {
          this.loading(false);
          // if (typeof response.data === "string") {
          //   const err = JSON.parse(response.data);
          //   this.errorMSG = err.map((_e) => {
          //     const { no, employee_code, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date } = _e.error;
          //     return [no, employee_code, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date];
          //   });
          // }
          // else if (typeof response.data === "object") {
          //   const errArray = [];
          //   const err = response.data;
          //   for (const _t in err) {
          //     const key = _t.split(".");
          //     errArray[key[1]] = { ...errArray[key[1]], ...{ [key[2]]: err[_t] } };
          //   }

          //   this.errorMSG = errArray.map((_e) => {
          //     const { no, employee_code, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date } = _e;
          //     return [no, employee_code, job_category, employment_type, job_title, full_name, hire_date, current_position_date, contact_number, retirement_date];
          //   });
          // } else {
          this.customAlert("서버에서 오류가 발생했습니다. 관리자에게 문의해주세요");
          // }
        });
    },
    setSi(address) {
      if (!address) return;

      let returnData = "";
      const si = ["목포", "여수", "순천", "나주", "광양", "담양", "곡성", "구례", "고흥", "보성", "화순", "장흥", "강진", "해남", "영암", "무안", "함평", "영광", "장성", "완도", "진도", "신안"];
      si.map((_si) => {
        if (address.includes(_si)) returnData = _si;
      });
      return returnData;
    },
    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: !!title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },
    onClickTab(tabIndex) {
      if (tabIndex === 0) this.$router.push({ name: "list|tab", params: { boardId: 570 } });
      if (tabIndex === 1) this.$router.push({ name: "completionresults570" });
      if (tabIndex === 2) this.$router.push({ name: "list|tab", params: { boardId: 576 } });
      if (tabIndex === 3) this.$router.push({ name: "completionresults576" });
      if (tabIndex === 4) this.$router.push({ name: "list|tab", params: { boardId: 577 } });
      if (tabIndex === 5) this.$router.push({ name: "completionresults577" });
    },
  },
};
</script>

<style scoped lang="scss">
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: center;
    padding: 16px 4px;
  }

  th {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;

    background: #fafafa;
    border-top: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;

    border-bottom: 1px solid #cdcdcd;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }

  .check {
    justify-content: center !important;
    ::v-deep {
      span {
        margin: 0;
      }
    }
  }
}
.errMsg {
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #ea5455;
  margin-top: 2px;
}
</style>
